import TrinhLanhDaoKTDX from './chuyen-vien-nhap-lieu/TrinhLanhDaoKTDX.jsx';
import TrinhLanhDaoKTDXView from './chuyen-vien-nhap-lieu/TrinhLanhDaoKTDXView.jsx'
import LanhDaoGiaoViecKTDX from './lanh-dao/LanhDaoGiaoViecKTDX.jsx';
import LanhDaoGiaoViecKTDXView from './lanh-dao/LanhDaoGiaoViecKTDXView.jsx';
import ThongTinYeuCauKTDX from './ThongTinYeuCauKTDX.jsx';
import CanBoKiemTraDeXuatView from './chuyen-vien/CanBoKiemTraDeXuatView.jsx';
import CanBoKiemTraDeXuat from'./chuyen-vien/CanBoKiemTraDeXuat.jsx';

export {
  TrinhLanhDaoKTDX,
  TrinhLanhDaoKTDXView,
  LanhDaoGiaoViecKTDX,
  LanhDaoGiaoViecKTDXView,
  ThongTinYeuCauKTDX,
  CanBoKiemTraDeXuatView,
  CanBoKiemTraDeXuat
}


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/index.js